import { Injectable, inject } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Confirmation} from './confirmation/confirmation';
import {Observable} from 'rxjs';
import {ConfirmationComponent} from './confirmation/confirmation.component';
import {Option, Select} from './select/select';
import {SelectComponent} from './select/select.component';
import {filter} from 'rxjs/operators';
import {Information, NavigationButton} from './information/information';
import {InformationComponent} from './information/information.component';
import {Textarea} from './textarea/textarea';
import {TextareaComponent} from './textarea/textarea.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private dialog = inject(MatDialog);

  showInformation(message: string, navigationButtons?: NavigationButton[]): void {
    const information: Information = {message, navigationButtons};
    this.dialog.open(InformationComponent, {data: information});
  }

  askConfirmation({title, message, yesLabel = 'Ok', noLabel = 'Annuleer'}: Confirmation): Observable<boolean> {
    const confirmation: Confirmation = {title, message, yesLabel, noLabel};
    return this.dialog
      .open(ConfirmationComponent, {data: confirmation})
      .afterClosed();
  }

  askSelection<T extends Option>(
    {title, message, optionList, defaultValue, confirmLabel = 'Ok', cancelLabel = 'Annuleer'}: Select<T>
  ): Observable<T> {
    const select: Select<T> = {title, message, optionList, defaultValue, confirmLabel, cancelLabel};
    return this.dialog
      .open(SelectComponent, {data: select})
      .afterClosed()
      .pipe(filter(result => !!result));
  }

  askText({title, message, label, placeholder, text, confirmLabel = 'Ok', cancelLabel = 'Annuleer', width = '65%'}: Textarea): Observable<string> {
    const textarea: Textarea = {title, message, label, placeholder, text, confirmLabel, cancelLabel};
    return this.dialog
      .open(TextareaComponent, {data: textarea, width})
      .afterClosed()
      .pipe(filter(result => !!result));
  }

  askDialog<T>(dialogComponent: any, data?: any, width = '65%'): Observable<T> {
    return this.dialog
      .open(dialogComponent, {data, width})
      .afterClosed()
      .pipe(filter(result => !!result));
  }
}
